import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import html2canvas from 'html2canvas';
import './QRCodeDownloadTemplate.css'; // We'll create this CSS file next

// Placeholder for the logo - replace with your actual logo path or import
// import logo from '../assets/checkmenus-logo.png'; // Example import
// const logoUrl = '/path/to/your/checkmenus-logo.png'; // Or use a direct path/URL if not importing
const logoUrl = '/logo192.png'; // Use the logo from the public folder

const QRCodeDownloadTemplate = ({ menuUrl, restaurantName }) => {
  const qrCodeTemplateRef = useRef(null);

  const handleDownload = async () => {
    if (!qrCodeTemplateRef.current) return;

    try {
      const canvas = await html2canvas(qrCodeTemplateRef.current, {
        scale: 2, // Increase scale for better resolution
        useCORS: true, // Important if logo is hosted externally
        backgroundColor: null, // Use transparent background if needed, or set a color
      });
      const dataUrl = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `${restaurantName || 'qrcode'}-menu.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error generating QR code image:', error);
      alert('Failed to download QR code image.');
    }
  };

  if (!menuUrl) {
    return <div>Loading QR Code...</div>; // Or some placeholder
  }

  return (
    <div className="qr-code-download-container">
      <div ref={qrCodeTemplateRef} className="qr-code-template">
        {/* Checkmenus Logo - Ensure the path is correct */} 
        <img src={logoUrl} alt="Checkmenus Logo" className="qr-logo" />
        
        {/* Menu URL */} 
        <p className="qr-menu-url">{menuUrl}</p>
        
        {/* QR Code */} 
        <div className="qr-code-wrapper">
          <QRCodeCanvas value={menuUrl} size={128} level="H" includeMargin={true} />
        </div>
        
        {/* Scan Me Text */} 
        <p className="qr-scan-text">Scan Me</p>
      </div>
      
      <button onClick={handleDownload} className="qr-download-button">
        Download QR Code
      </button>
    </div>
  );
};

export default QRCodeDownloadTemplate;